import React from "react";
import LocationFleetCms from "./LocationFleetCms";

const PrivateYachtCms = () => (
  <LocationFleetCms
    pageKey="private-yacht-charter-mumbai-goa"
    heading="Private Yacht"
    intro="Manage yachts for the Private Yacht Charter page. Tick Mumbai and/or Goa so the same yacht can appear in both locations."
  />
);

export default PrivateYachtCms;
